import { render, staticRenderFns } from "./import-dialog.vue?vue&type=template&id=20fce362&scoped=true"
import script from "./import-dialog.vue?vue&type=script&lang=js"
export * from "./import-dialog.vue?vue&type=script&lang=js"
import style0 from "./import-dialog.vue?vue&type=style&index=0&id=20fce362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fce362",
  null
  
)

export default component.exports